// import { FC } from 'react';
// import { Modal } from 'react-bootstrap';

// interface UserTableModalProps {
//     user: any;
//     onClose: () => void;
//     show: boolean;
// }

// export const AggrigatorKyc: FC<UserTableModalProps> = ({ user, onClose, show }) => {
//     const getAadharNumber = () => {
//         const aadharDoc = user?.kycDocument?.find((doc: any) =>
//             doc?.docType === 'AADHAR'
//         );
//         return aadharDoc?.docNumber || 'N/A';
//     };

//     const getPanNumber = () => {
//         const panDoc = user?.kycDocument?.find((doc: any) =>
//             doc?.docType === 'PAN'
//         );
//         return panDoc?.docNumber || 'N/A';
//     };

//     const getGstNumber = () => {
//         const gstDoc = user?.kycDocument?.find((doc: any) =>
//             doc?.docType === 'GST_NUMBER'
//         );
//         return gstDoc?.docNumber || 'N/A';
//     };

//     const getCinDocument = () => {
//         const cinDoc = user?.kycDocument?.find((doc: any) =>
//             doc?.docType === 'CIN'
//         );
//         return {
//             number: cinDoc?.docNumber || 'N/A',
//             url: cinDoc?.docUrl || ''
//         };
//     };

//     const getCinId = () => {
//         const cinIdDoc = user?.kycDocument?.find((doc: any) =>
//             doc?.docType === 'CIN'
//         );
//         return {
//             number: cinIdDoc?.docNumber || 'N/A',
//             url: cinIdDoc?.docUrl || ''
//         };
//     };

//     return (
//         <Modal
//             className='modal fade'
//             id='kt_modal_view_user'
//             data-backdrop='static'
//             tabIndex={-1}
//             role='dialog'
//             show={show}
//             centered
//             size="lg"
//         >
//             <div className="modal-content">
//                 <div className="modal-header pb-0 border-0 justify-content-end">
//                     <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}>
//                     </div>
//                 </div>

//                 <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
//                     <div className="text-center mb-13">
//                         <h1 className="mb-3">KYC Details</h1>
//                     </div>

//                     {/* <div className="table-responsive">
//                         <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
//                             <thead>
//                                 <tr className="fw-bold text-muted bg-light">
//                                     <th className="min-w-100px ps-4">Aadhar No</th>
//                                     <th className="min-w-100px">PAN</th>
//                                     <th className="min-w-100px">GST</th>
//                                     <th className="min-w-100px">CIN</th>
//                                     <th className="min-w-100px">CIN ID</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 <tr>
//                                     <td className="ps-4">
//                                         <span className="text-dark fw-semibold d-block fs-6">
//                                             {getAadharNumber()}
//                                         </span>
//                                     </td>
//                                     <td>
//                                         <span className="text-dark fw-semibold d-block fs-6">
//                                             {getPanNumber()}
//                                         </span>
//                                     </td>
//                                     <td>
//                                         <span className="text-dark fw-semibold d-block fs-6">
//                                             {getGstNumber()}
//                                         </span>
//                                     </td>
//                                     <td>
//                                         <span className="text-dark fw-semibold d-block fs-6">
//                                             {getCinDocument().number}
//                                         </span>
//                                     </td>
//                                     <td>
//                                         <span className="text-dark fw-semibold d-block fs-6">
//                                             {getCinDocument().url && (
//                                                 <a
//                                                     href={getCinDocument().url}
//                                                     target="_blank"
//                                                     rel="noopener noreferrer"
//                                                     className="ms-2"
//                                                 >
//                                                     <img
//                                                         src={getCinDocument().url}
//                                                         alt="CIN Document"
//                                                         style={{
//                                                             maxWidth: '100px',
//                                                             maxHeight: '100px',
//                                                             objectFit: 'contain'
//                                                         }}
//                                                     />
//                                                 </a>
//                                             )}
//                                         </span>
//                                     </td>
//                                 </tr>
//                             </tbody>
//                         </table>
//                     </div> */}

//                     <div className="table-responsive">
//                         <table style={{
//                             width: "100%",
//                             borderCollapse: "collapse",
//                             marginBottom: "20px",
//                             border: "1px solid #ddd"
//                         }}>
//                             <thead>
//                                 <tr>
//                                     <th colSpan={2} style={{
//                                         backgroundColor: "#BFD7ED",
//                                         color: "black",
//                                         fontWeight: "bold",
//                                         padding: "12px",
//                                         textAlign: "left",
//                                         border: "1px solid #ddd"
//                                     }}>
//                                         Document Details
//                                     </th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 <tr>
//                                     <td style={{
//                                         width: "30%",
//                                         padding: "10px",
//                                         border: "1px solid #ddd",
//                                         fontWeight: "bold"
//                                     }}>
//                                         Aadhar No
//                                     </td>
//                                     <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                         {getAadharNumber() || 'N/A'}
//                                     </td>
//                                 </tr>
//                                 <tr>
//                                     <td style={{
//                                         padding: "10px",
//                                         border: "1px solid #ddd",
//                                         fontWeight: "bold"
//                                     }}>
//                                         PAN
//                                     </td>
//                                     <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                         {getPanNumber() || 'N/A'}
//                                     </td>
//                                 </tr>
//                                 <tr>
//                                     <td style={{
//                                         padding: "10px",
//                                         border: "1px solid #ddd",
//                                         fontWeight: "bold"
//                                     }}>
//                                         GST
//                                     </td>
//                                     <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                         {getGstNumber() || 'N/A'}
//                                     </td>
//                                 </tr>
//                                 <tr>
//                                     <td style={{
//                                         padding: "10px",
//                                         border: "1px solid #ddd",
//                                         fontWeight: "bold"
//                                     }}>
//                                         CIN
//                                     </td>
//                                     <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                         {getCinDocument()?.number || 'N/A'}
//                                     </td>
//                                 </tr>
//                                 <tr>
//                                     <td style={{
//                                         padding: "10px",
//                                         border: "1px solid #ddd",
//                                         fontWeight: "bold"
//                                     }}>
//                                         CIN ID
//                                     </td>
//                                     <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                         {getCinDocument()?.url ? (
//                                             <a
//                                                 href={getCinDocument().url}
//                                                 target="_blank"
//                                                 rel="noopener noreferrer"
//                                             >
//                                                 <img
//                                                     src={getCinDocument().url}
//                                                     alt="CIN Document"
//                                                     style={{
//                                                         maxWidth: '100px',
//                                                         maxHeight: '100px',
//                                                         objectFit: 'contain'
//                                                     }}
//                                                 />
//                                             </a>
//                                         ) : 'N/A'}
//                                     </td>
//                                 </tr>
//                             </tbody>
//                         </table>
//                     </div>


//                     <div className="modal-footer">
//                         <button
//                             type="button"
//                             className="btn btn-light"
//                             onClick={onClose}
//                         >
//                             Close
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         </Modal>
//     );
// };




















// import { FC, useState, useEffect } from 'react';
// import { Modal } from 'react-bootstrap';
// // import { useAuth } from '../../../../../../../_metronic/core';
// import { useAuth } from '../../../../../auth';
// import UploadImage from '../../../../../../../_metronic/helpers/components/ImageUpload';
// import { useFormik } from 'formik';
// import { useLocation } from 'react-router-dom';
// import { successToast } from '../../../../../../../_metronic/helpers/components/Toaster';

// interface UserTableModalProps {
//     user: any;
//     onClose: () => void;
//     show: boolean;
// }

// export const AggrigatorKyc: FC<UserTableModalProps> = ({ user, onClose, show }) => {
//     const { currentUser } = useAuth();
//     const isAdmin = (currentUser as any)?.role?.name === "ADMIN_CXO";
//     const location = useLocation();
//     const isRecyclerPath = location.pathname.includes('/apps/business/recycler');
//     const isCollectionPointPath = location.pathname.includes('/apps/business/collection-point');
//     const canEdit = isAdmin && (isRecyclerPath || isCollectionPointPath);

//     const [kycFields, setKycFields] = useState({
//         aadhar: '',
//         pan: '',
//         gst: '',
//         cin: '',
//         cinImageUrl: '' // Add this
//     });

//     const [originalFields, setOriginalFields] = useState({
//         aadhar: '',
//         pan: '',
//         gst: '',
//         cin: '',
//         cinImageUrl: '' // Add this
//     });

//     const [hasChanges, setHasChanges] = useState(false);
//     const [isLoading, setIsLoading] = useState(false);


//     const formik = useFormik({
//         initialValues: {
//             cinImage: kycFields.cinImageUrl
//         },
//         onSubmit: () => { },
//         enableReinitialize: true
//     });

//     const getAadharNumber = () => {
//         const aadharDoc = user?.kycDocument?.find((doc: any) =>
//             doc?.docType === 'AADHAR'
//         );
//         return aadharDoc?.docNumber || 'N/A';
//     };

//     const getPanNumber = () => {
//         const panDoc = user?.kycDocument?.find((doc: any) =>
//             doc?.docType === 'PAN'
//         );
//         return panDoc?.docNumber || 'N/A';
//     };

//     const getGstNumber = () => {
//         const gstDoc = user?.kycDocument?.find((doc: any) =>
//             doc?.docType === 'GST_NUMBER'
//         );
//         return gstDoc?.docNumber || 'N/A';
//     };

//     const getCinDocument = () => {
//         const cinDoc = user?.kycDocument?.find((doc: any) =>
//             doc?.docType === 'CIN'
//         );
//         return {
//             number: cinDoc?.docNumber || 'N/A',
//             url: cinDoc?.docUrl || ''
//         };
//     };

//     const getCinId = () => {
//         const cinIdDoc = user?.kycDocument?.find((doc: any) =>
//             doc?.docType === 'CIN'
//         );
//         return {
//             number: cinIdDoc?.docNumber || 'N/A',
//             url: cinIdDoc?.docUrl || ''
//         };
//     };

//     // Initialize fields when user data changes
//     useEffect(() => {
//         if (user?.kycDocument) {
//             const initialFields = {
//                 aadhar: getAadharNumber(),
//                 pan: getPanNumber(),
//                 gst: getGstNumber(),
//                 cin: getCinDocument().number,
//                 cinImageUrl: getCinDocument().url // Add this
//             };
//             setKycFields(initialFields);
//             setOriginalFields(initialFields);
//         }
//     }, [user]);

//     useEffect(() => {
//         if (formik.values.cinImage !== kycFields.cinImageUrl) {
//             setKycFields(prev => ({
//                 ...prev,
//                 cinImageUrl: formik.values.cinImage
//             }));
//         }
//     }, [formik.values.cinImage]);

//     // Check for changes
//     useEffect(() => {
//         const fieldsChanged = Object.keys(kycFields).some(
//             key => kycFields[key as keyof typeof kycFields] !== originalFields[key as keyof typeof originalFields]
//         );
//         const imageChanged = formik.values.cinImage !== (user?.kycDocument?.find(doc => doc.docType === 'CIN')?.docUrl || '');
//         setHasChanges(fieldsChanged || imageChanged);
//     }, [kycFields, originalFields, formik.values.cinImage]);

//     const handleFieldChange = (field: keyof typeof kycFields, value: string) => {
//         setKycFields(prev => ({
//             ...prev,
//             [field]: value
//         }));
//     };

//     const handleSave = async () => {
//         if (!hasChanges || !user?.id) return;

//         setIsLoading(true);
//         try {
//             const updatedPayload = {
//                 pickupPointStaffId: user.pickupPointStaffId,
//                 pickupPointStaffName: user.pickupPointStaffName,
//                 firstName: user.personalDetails?.name || "",
//                 email: user.personalDetails?.email || "",
//                 mobile: user.personalDetails?.mobile || "",
//                 userType: "PICKUP_POINT",
//                 countryCode: "91",
//                 franchiseId: user.franchiseId || "",
//                 status: "ACTIVE",
//                 kycDocument: [
//                     {
//                         docUrl: formik.values.cinImage || user.kycDocument?.[0]?.docUrl || "",
//                         docNumber: kycFields.cin,
//                         docType: "CIN"
//                     },
//                     {
//                         docUrl: user.kycDocument?.[1]?.docUrl || "",
//                         docNumber: kycFields.aadhar,
//                         docType: "AADHAR"
//                     },
//                     {
//                         docUrl: user.kycDocument?.[2]?.docUrl || "",
//                         docNumber: kycFields.gst,
//                         docType: "GST_NUMBER"
//                     },
//                     {
//                         docUrl: user.kycDocument?.[3]?.docUrl || "",
//                         docNumber: kycFields.pan,
//                         docType: "PAN"
//                     }
//                 ],
//                 companyDetails: {
//                     name: user.companyDetails?.name || "",
//                     companyId: user.companyDetails?.companyId || ""
//                 },
//                 address: [
//                     {
//                         addressType: "OFFICE_ADDRESS",
//                         street: user.address?.[0]?.street || "",
//                         city: user.address?.[0]?.city || "",
//                         zipCode: user.address?.[0]?.zipCode || "",
//                         country: user.address?.[0]?.country || "India",
//                         state: user.address?.[0]?.state || ""
//                     }
//                 ],
//                 bankDetails: {
//                     bankName: user.bankDetails?.bankName || "",
//                     accountNo: user.bankDetails?.accountNo || "",
//                     ifscCode: user.bankDetails?.ifscCode || "",
//                     accountName: user.bankDetails?.accountName || "",
//                     images: [
//                         {
//                             docUrl: user.bankDetails?.images?.[0]?.docUrl || "",
//                             docType: "CANCEL_CHEQUE"
//                         }
//                     ]
//                 }
//             };

//             const response = await fetch(`https://pfc-backend-api.asmglobal.co.in/v1/api/users/${user.id}/update`, {
//                 method: 'PUT',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify(updatedPayload)
//             });

//             if (!response.ok) {
//                 throw new Error('Failed to update user');
//             }
//             successToast('Modified');
//             setOriginalFields(kycFields);
//             setHasChanges(false);

//         } catch (error) {
//             console.error('Error updating user:', error);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleClose = () => {
//         setKycFields(originalFields);
//         setHasChanges(false);
//         onClose();
//     };

//     return (
//         <Modal
//             className='modal fade'
//             id='kt_modal_view_user'
//             data-backdrop='static'
//             tabIndex={-1}
//             role='dialog'
//             show={show}
//             centered
//             size="lg"
//         >
//             <div className="modal-content">
//                 <div className="modal-header pb-0 border-0 justify-content-end">
//                     <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={handleClose}>
//                         ×
//                     </div>
//                 </div>

//                 <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
//                     <div className="text-center mb-13">
//                         <h1 className="mb-3">KYC Details</h1>
//                     </div>

//                     <div className="table-responsive">
//                         <table style={{
//                             width: "100%",
//                             borderCollapse: "collapse",
//                             marginBottom: "20px",
//                             border: "1px solid #ddd"
//                         }}>
//                             <thead>
//                                 <tr>
//                                     <th colSpan={2} style={{
//                                         backgroundColor: "#BFD7ED",
//                                         color: "black",
//                                         fontWeight: "bold",
//                                         padding: "12px",
//                                         textAlign: "left",
//                                         border: "1px solid #ddd"
//                                     }}>
//                                         Document Details
//                                     </th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 <tr>
//                                     <td style={{
//                                         width: "30%",
//                                         padding: "10px",
//                                         border: "1px solid #ddd",
//                                         fontWeight: "bold"
//                                     }}>
//                                         Aadhar No
//                                     </td>
//                                     <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                         {canEdit ? (
//                                             <input
//                                                 type="text"
//                                                 value={kycFields.aadhar}
//                                                 onChange={(e) => handleFieldChange('aadhar', e.target.value)}
//                                                 style={{
//                                                     width: "100%",
//                                                     border: "1px solid #ccc",
//                                                     borderRadius: "4px",
//                                                     padding: "8px",
//                                                     fontSize: "14px"
//                                                 }}
//                                                 placeholder="Enter Aadhar number"
//                                             />
//                                         ) : (
//                                             <span>{kycFields.aadhar || 'N/A'}</span>
//                                         )}
//                                     </td>
//                                 </tr>
//                                 <tr>
//                                     <td style={{
//                                         padding: "10px",
//                                         border: "1px solid #ddd",
//                                         fontWeight: "bold"
//                                     }}>
//                                         PAN
//                                     </td>
//                                     <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                         {canEdit ? (
//                                             <input
//                                                 type="text"
//                                                 value={kycFields.pan}
//                                                 onChange={(e) => handleFieldChange('pan', e.target.value)}
//                                                 style={{
//                                                     width: "100%",
//                                                     border: "1px solid #ccc",
//                                                     borderRadius: "4px",
//                                                     padding: "8px",
//                                                     fontSize: "14px"
//                                                 }}
//                                                 placeholder="Enter PAN number"
//                                             />
//                                         ) : (
//                                             <span>{kycFields.pan || 'N/A'}</span>
//                                         )}
//                                     </td>
//                                 </tr>
//                                 <tr>
//                                     <td style={{
//                                         padding: "10px",
//                                         border: "1px solid #ddd",
//                                         fontWeight: "bold"
//                                     }}>
//                                         GST
//                                     </td>
//                                     <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                         {canEdit ? (
//                                             <input
//                                                 type="text"
//                                                 value={kycFields.gst}
//                                                 onChange={(e) => handleFieldChange('gst', e.target.value)}
//                                                 style={{
//                                                     width: "100%",
//                                                     border: "1px solid #ccc",
//                                                     borderRadius: "4px",
//                                                     padding: "8px",
//                                                     fontSize: "14px"
//                                                 }}
//                                                 placeholder="Enter GST number"
//                                             />
//                                         ) : (
//                                             <span>{kycFields.gst || 'N/A'}</span>
//                                         )}
//                                     </td>
//                                 </tr>
//                                 <tr>
//                                     <td style={{
//                                         padding: "10px",
//                                         border: "1px solid #ddd",
//                                         fontWeight: "bold"
//                                     }}>
//                                         CIN
//                                     </td>
//                                     <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                         {canEdit ? (
//                                             <input
//                                                 type="text"
//                                                 value={kycFields.cin}
//                                                 onChange={(e) => handleFieldChange('cin', e.target.value)}
//                                                 style={{
//                                                     width: "100%",
//                                                     border: "1px solid #ccc",
//                                                     borderRadius: "4px",
//                                                     padding: "8px",
//                                                     fontSize: "14px"
//                                                 }}
//                                                 placeholder="Enter CIN number"
//                                             />
//                                         ) : (
//                                             <span>{kycFields.cin || 'N/A'}</span>
//                                         )}
//                                     </td>
//                                 </tr>
//                                 <tr>
//                                     <td style={{
//                                         padding: "10px",
//                                         border: "1px solid #ddd",
//                                         fontWeight: "bold"
//                                     }}>
//                                         CIN ID
//                                     </td>
//                                     <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                         {canEdit ? (
//                                             <UploadImage name='cinImage' formik={formik} label='Upload CIN Document' />
//                                         ) : (
//                                             kycFields.cinImageUrl ? (
//                                                 <a
//                                                     href={kycFields.cinImageUrl}
//                                                     target="_blank"
//                                                     rel="noopener noreferrer"
//                                                 >
//                                                     <img
//                                                         src={kycFields.cinImageUrl}
//                                                         alt="CIN Document"
//                                                         style={{
//                                                             maxWidth: '100px',
//                                                             maxHeight: '100px',
//                                                             objectFit: 'contain'
//                                                         }}
//                                                     />
//                                                 </a>
//                                             ) : 'N/A'
//                                         )}
//                                     </td>
//                                 </tr>
//                             </tbody>
//                         </table>
//                     </div>

//                     <div className="modal-footer">
//                         <button
//                             type="button"
//                             className="btn btn-light"
//                             onClick={handleClose}
//                         >
//                             Close
//                         </button>
//                         {canEdit && (
//                             <button
//                                 type="button"
//                                 className={`btn ${hasChanges ? 'btn-primary' : 'btn-secondary'}`}
//                                 onClick={handleSave}
//                                 disabled={!hasChanges || isLoading}
//                                 style={{
//                                     marginLeft: "10px",
//                                     opacity: hasChanges ? 1 : 0.6,
//                                     cursor: hasChanges ? 'pointer' : 'not-allowed'
//                                 }}
//                             >
//                                 {isLoading ? 'Saving...' : 'Save Changes'}
//                             </button>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </Modal>
//     );
// };













import { FC, useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
// import { useAuth } from '../../../../../../../_metronic/core';
import { useAuth } from '../../../../../auth';
import UploadImage from '../../../../../../../_metronic/helpers/components/ImageUpload';
import { useFormik } from 'formik';
import { useLocation } from 'react-router-dom';
import { successToast } from '../../../../../../../_metronic/helpers/components/Toaster';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}

export const AggrigatorKyc: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    const { currentUser } = useAuth();
    const isAdmin = (currentUser as any)?.role?.name === "ADMIN_CXO";
    const location = useLocation();
    const isRecyclerPath = location.pathname.includes('/apps/business/recycler');
    const isCollectionPointPath = location.pathname.includes('/apps/business/collection-point');

    const isRecyclerPathFinance = location.pathname.includes('/apps/finance/recycler');
    const isCollectionPointPathFinance = location.pathname.includes('/apps/finance/collection-point');
    // const canEdit = isAdmin && (isRecyclerPath || isCollectionPointPath);
    const canEdit = isAdmin && (isRecyclerPath || isRecyclerPathFinance || isCollectionPointPath || isCollectionPointPathFinance);



    // const [kycFields, setKycFields] = useState({
    //     aadhar: '',
    //     pan: '',
    //     gst: '',
    //     cin: '',
    //     cinImageUrl: '' 
    // });


    const handleImageError = (docType: 'gst' | 'pan') => {
        setImageErrors(prev => ({
            ...prev,
            [docType]: true
        }));
    };

    const handleImageLoad = (docType: 'gst' | 'pan') => {
        setImageErrors(prev => ({
            ...prev,
            [docType]: false
        }));
    };

    const [kycFields, setKycFields] = useState({
        aadhar: '',
        pan: '',
        gst: '',
        gstImageUrl: '',
        panImageUrl: '',
        aadharImageUrl: ''
    });

    // const [originalFields, setOriginalFields] = useState({
    //     aadhar: '',
    //     pan: '',
    //     gst: '',
    //     cin: '',
    //     cinImageUrl: '' 
    // });
    const [originalFields, setOriginalFields] = useState({
        aadhar: '',
        pan: '',
        gst: '',
        gstImageUrl: '',
        panImageUrl: '',
        aadharImageUrl: ''
    });

    const [hasChanges, setHasChanges] = useState(false);
    const [isLoading, setIsLoading] = useState(false);


    const formik = useFormik({
        // initialValues: {
        //     cinImage: kycFields.cinImageUrl
        // },
        initialValues: {
            gstImage: kycFields.gstImageUrl,
            panImage: kycFields.panImageUrl,
            aadharImage: kycFields.aadharImageUrl
        },
        onSubmit: () => { },
        enableReinitialize: true
    });


    // useEffect(() => {
    //     const fieldsChanged = Object.keys(kycFields).some(
    //         key => kycFields[key as keyof typeof kycFields] !== originalFields[key as keyof typeof originalFields]
    //     );
    //     const gstImageChanged = formik.values.gstImage !== (user?.kycDocument?.find(doc => doc.docType === 'GST_NUMBER' || doc.docType === 'GST_CERTIFICATE')?.docUrl || '');
    //     const panImageChanged = formik.values.panImage !== (user?.kycDocument?.find(doc => doc.docType === 'PAN')?.docUrl || '');
    //     setHasChanges(fieldsChanged || gstImageChanged || panImageChanged);
    // }, [kycFields, originalFields, formik.values.gstImage, formik.values.panImage]);


    useEffect(() => {
        console.log('=== CHANGE DETECTION RUNNING ===');
        console.log('kycFields:', kycFields);
        console.log('originalFields:', originalFields);

        const fieldsChanged = Object.keys(kycFields).some(
            key => {
                const current = kycFields[key as keyof typeof kycFields];
                const original = originalFields[key as keyof typeof originalFields];
                console.log(`Field ${key}: current="${current}", original="${original}", changed=${current !== original}`);
                return current !== original;
            }
        );

        console.log('Fields changed:', fieldsChanged);
        console.log('Current hasChanges:', hasChanges);

        const gstImageChanged = formik.values.gstImage !== (user?.kycDocument?.find(doc => doc.docType === 'GST_NUMBER' || doc.docType === 'GST_CERTIFICATE')?.docUrl || '');
        const panImageChanged = formik.values.panImage !== (user?.kycDocument?.find(doc => doc.docType === 'PAN')?.docUrl || '');
        const aadharImageChanged = formik.values.aadharImage !== (user?.kycDocument?.find(doc => doc.docType === 'AADHAR')?.docUrl || '');

        const totalHasChanges = fieldsChanged || gstImageChanged || panImageChanged || aadharImageChanged;
        console.log('Setting hasChanges to:', totalHasChanges);

        setHasChanges(totalHasChanges);
        console.log('=================================');
    }, [kycFields, originalFields, formik.values.gstImage, formik.values.panImage, formik.values.aadharImage]);


    const getGstDocument = () => {
        const gstDoc = user?.kycDocument?.find((doc: any) =>
            doc?.docType === 'GST_NUMBER' || doc?.docType === 'GST_CERTIFICATE'
        );
        return {
            number: gstDoc?.docNumber || '',
            url: gstDoc?.docUrl || ''
        };
    };

    const getGstNumber = () => {
        const gstDoc = user?.kycDocument?.find((doc: any) =>
            doc?.docType === 'GST_NUMBER' || doc?.docType === 'GST_CERTIFICATE'
        );
        return gstDoc?.docNumber || 'N/A';
    };

    const getPanDocument = () => {
        const panDoc = user?.kycDocument?.find((doc: any) =>
            doc?.docType === 'PAN'
        );
        return {
            number: panDoc?.docNumber || '',
            url: panDoc?.docUrl || ''
        };
    };


    const getAadharNumber = () => {
        const aadharDoc = user?.kycDocument?.find((doc: any) =>
            doc?.docType === 'AADHAR'
        );
        return aadharDoc?.docNumber || '';
    };

    const getPanNumber = () => {
        const panDoc = user?.kycDocument?.find((doc: any) =>
            doc?.docType === 'PAN'
        );
        return panDoc?.docNumber || 'N/A';
    };

    const getCinDocument = () => {
        const cinDoc = user?.kycDocument?.find((doc: any) =>
            doc?.docType === 'CIN'
        );
        return {
            number: cinDoc?.docNumber || 'N/A',
            url: cinDoc?.docUrl || ''
        };
    };

    const getCinId = () => {
        const cinIdDoc = user?.kycDocument?.find((doc: any) =>
            doc?.docType === 'CIN'
        );
        return {
            number: cinIdDoc?.docNumber || 'N/A',
            url: cinIdDoc?.docUrl || ''
        };
    };




    useEffect(() => {
        setImageErrors({ gst: false, pan: false });
    }, [user]);
    const [imageErrors, setImageErrors] = useState({
        gst: false,
        pan: false
    });

    // Initialize fields when user data changes
    // useEffect(() => {
    //     if (user?.kycDocument) {
    //         const initialFields = {
    //             aadhar: getAadharNumber(),
    //             pan: getPanNumber(),
    //             gst: getGstNumber(),
    //             cin: getCinDocument().number,
    //             cinImageUrl: getCinDocument().url // Add this
    //         };
    //         setKycFields(initialFields);
    //         setOriginalFields(initialFields);
    //     }
    // }, [user]);

    useEffect(() => {
        if (user?.kycDocument) {
            console.log('All KYC Documents:', user.kycDocument);
            console.log('Formik values:', formik.values);
            console.log('GST Image URL:', kycFields.gstImageUrl);
            console.log('PAN Image URL:', kycFields.panImageUrl);

            const gstDoc = getGstDocument();
            const panDoc = getPanDocument();

            console.log('GST Document:', gstDoc);
            console.log('PAN Document:', panDoc);

            const initialFields = {
                aadhar: getAadharNumber(),
                pan: panDoc.number,
                gst: gstDoc.number,
                gstImageUrl: gstDoc.url,
                panImageUrl: panDoc.url,
                aadharImageUrl: getAadharDocument().url
            };

            console.log('Initial Fields being set:', initialFields);
            setKycFields(initialFields);
            setOriginalFields(initialFields);
        }
    }, [user]);

    const getAadharDocument = () => {
        const aadharDoc = user?.kycDocument?.find((doc: any) =>
            doc?.docType === 'AADHAR'
        );
        return {
            number: aadharDoc?.docNumber || 'N/A',
            url: aadharDoc?.docUrl || ''
        };
    };



    const [documentTypes, setDocumentTypes] = useState<{ gst: 'image' | 'pdf', pan: 'image' | 'pdf', aadhar: 'image' | 'pdf' }>({
        gst: 'image',
        pan: 'image',
        aadhar: 'image'
    });


    const handleAadharImageError = () => {
        setDocumentTypes(prev => ({ ...prev, aadhar: 'pdf' }));
    };

    const handleGstImageError = () => {
        setDocumentTypes(prev => ({ ...prev, gst: 'pdf' }));
    };

    const handlePanImageError = () => {
        setDocumentTypes(prev => ({ ...prev, pan: 'pdf' }));
    };

    useEffect(() => {
        setDocumentTypes({ gst: 'image', pan: 'image', aadhar: 'image' });
    }, [user]);

    // useEffect(() => {
    //     if (formik.values.cinImage !== kycFields.cinImageUrl) {
    //         setKycFields(prev => ({
    //             ...prev,
    //             cinImageUrl: formik.values.cinImage
    //         }));
    //     }
    // }, [formik.values.cinImage]);


    useEffect(() => {
        let hasUpdate = false;
        const newFields = { ...kycFields };

        if (formik.values.gstImage !== kycFields.gstImageUrl) {
            newFields.gstImageUrl = formik.values.gstImage;
            hasUpdate = true;
        }

        if (formik.values.panImage !== kycFields.panImageUrl) {
            newFields.panImageUrl = formik.values.panImage;
            hasUpdate = true;
        }

        if (formik.values.aadharImage !== kycFields.aadharImageUrl) {
            newFields.aadharImageUrl = formik.values.aadharImage;
            hasUpdate = true;
        }

        if (hasUpdate) {
            setKycFields(newFields);
        }
    }, [formik.values.gstImage, formik.values.panImage, formik.values.aadharImage]);



    // Check for changes
    // useEffect(() => {
    //     const fieldsChanged = Object.keys(kycFields).some(
    //         key => kycFields[key as keyof typeof kycFields] !== originalFields[key as keyof typeof originalFields]
    //     );
    //     const imageChanged = formik.values.cinImage !== (user?.kycDocument?.find(doc => doc.docType === 'CIN')?.docUrl || '');
    //     setHasChanges(fieldsChanged || imageChanged);
    // }, [kycFields, originalFields, formik.values.cinImage]);



    const handleFieldChange = (field: keyof typeof kycFields, value: string) => {
        setKycFields(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSave = async () => {
        if (!hasChanges || !user?.id) return;

        setIsLoading(true);
        try {
            const updatedPayload = {
                pickupPointStaffId: user.pickupPointStaffId,
                pickupPointStaffName: user.pickupPointStaffName,
                firstName: user.personalDetails?.name || "",
                email: user.personalDetails?.email || "",
                mobile: user.personalDetails?.mobile || "",
                userType: "PICKUP_POINT",
                countryCode: "91",
                franchiseId: user.franchiseId || "",
                status: "ACTIVE",
                // kycDocument: [

                //     {
                //         docUrl: user.kycDocument?.[1]?.docUrl || "",
                //         docNumber: kycFields.aadhar,
                //         docType: "AADHAR"
                //     },
                //     {
                //         docUrl: user.kycDocument?.[2]?.docUrl || "",
                //         docNumber: kycFields.gst,
                //         docType: "GST_NUMBER"
                //     },
                //     {
                //         docUrl: user.kycDocument?.[3]?.docUrl || "",
                //         docNumber: kycFields.pan,
                //         docType: "PAN"
                //     }
                // ],

                kycDocument: [
                    {
                        docUrl: formik.values.aadharImage || user.kycDocument?.find(doc => doc.docType === 'AADHAR')?.docUrl || "",
                        docNumber: kycFields.aadhar,
                        docType: "AADHAR"
                    },
                    {
                        docUrl: formik.values.gstImage || user.kycDocument?.find(doc => doc.docType === 'GST_NUMBER' || doc.docType === 'GST_CERTIFICATE')?.docUrl || "",
                        docNumber: kycFields.gst,
                        docType: "GST_CERTIFICATE"
                    },
                    {
                        docUrl: formik.values.panImage || user.kycDocument?.find(doc => doc.docType === 'PAN')?.docUrl || "",
                        docNumber: kycFields.pan,
                        docType: "PAN"
                    }
                ],

                companyDetails: {
                    name: user.companyDetails?.name || "",
                    companyId: user.companyDetails?.companyId || ""
                },
                address: [
                    {
                        addressType: "OFFICE_ADDRESS",
                        street: user.address?.[0]?.street || "",
                        city: user.address?.[0]?.city || "",
                        zipCode: user.address?.[0]?.zipCode || "",
                        country: user.address?.[0]?.country || "India",
                        state: user.address?.[0]?.state || ""
                    }
                ],
                bankDetails: {
                    bankName: user.bankDetails?.bankName || "",
                    accountNo: user.bankDetails?.accountNo || "",
                    ifscCode: user.bankDetails?.ifscCode || "",
                    accountName: user.bankDetails?.accountName || "",
                    images: [
                        {
                            docUrl: user.bankDetails?.images?.[0]?.docUrl || "",
                            docType: "CANCEL_CHEQUE"
                        }
                    ]
                }
            };

            const response = await fetch(`https://pfc-backend-api.asmglobal.co.in/v1/api/users/${user.id}/update`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updatedPayload)
            });

            if (!response.ok) {
                throw new Error('Failed to update user');
            }
            successToast('Modified');
            setOriginalFields(kycFields);
            setHasChanges(false);

        } catch (error) {
            console.error('Error updating user:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setKycFields(originalFields);
        setHasChanges(false);
        onClose();
    };

    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={handleClose}>
                        X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">KYC Details</h1>
                    </div>

                    <div className="table-responsive">
                        <table style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            marginBottom: "20px",
                            border: "1px solid #ddd"
                        }}>
                            <thead>
                                <tr>
                                    <th colSpan={2} style={{
                                        backgroundColor: "#BFD7ED",
                                        color: "black",
                                        fontWeight: "bold",
                                        padding: "12px",
                                        textAlign: "left",
                                        border: "1px solid #ddd"
                                    }}>
                                        Document Details
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{
                                        width: "30%",
                                        padding: "10px",
                                        border: "1px solid #ddd",
                                        fontWeight: "bold"
                                    }}>
                                        Aadhar No
                                    </td>
                                    <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                        {canEdit ? (
                                            <input
                                                type="text"
                                                value={kycFields.aadhar}
                                                onChange={(e) => handleFieldChange('aadhar', e.target.value)}
                                                style={{
                                                    width: "100%",
                                                    border: kycFields.aadhar === '' ? "2px solid #fdb2c5" : "1px solid #ccc",
                                                    borderRadius: "4px",
                                                    padding: "8px",
                                                    fontSize: "14px"
                                                }}
                                                placeholder="Enter Aadhar number"
                                            />
                                        ) : (
                                            <span>{kycFields.aadhar || 'N/A'}</span>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: "10px",
                                        border: "1px solid #ddd",
                                        fontWeight: "bold"
                                    }}>
                                        PAN
                                    </td>
                                    <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                        {canEdit ? (
                                            <input
                                                type="text"
                                                value={kycFields.pan}
                                                onChange={(e) => handleFieldChange('pan', e.target.value)}
                                                style={{
                                                    width: "100%",
                                                    border: kycFields.pan === '' ? "2px solid #fdb2c5" : "1px solid #ccc",
                                                    borderRadius: "4px",
                                                    padding: "8px",
                                                    fontSize: "14px"
                                                }}
                                                placeholder="Enter PAN number"
                                            />
                                        ) : (
                                            <span>{kycFields.pan || 'N/A'}</span>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: "10px",
                                        border: "1px solid #ddd",
                                        fontWeight: "bold"
                                    }}>
                                        GST
                                    </td>
                                    <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                        {canEdit ? (
                                            <input
                                                type="text"
                                                value={kycFields.gst}
                                                onChange={(e) => handleFieldChange('gst', e.target.value)}
                                                style={{
                                                    width: "100%",
                                                    border: kycFields.gst === '' ? "2px solid #fdb2c5" : "1px solid #ccc",
                                                    borderRadius: "4px",
                                                    padding: "8px",
                                                    fontSize: "14px"
                                                }}
                                                placeholder="Enter GST number"
                                            />
                                        ) : (
                                            <span>{kycFields.gst || 'N/A'}</span>
                                        )}
                                    </td>
                                </tr>
                                {/* <tr>
                                    <td style={{
                                        padding: "10px",
                                        border: "1px solid #ddd",
                                        fontWeight: "bold"
                                    }}>
                                        CIN
                                    </td>
                                    <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                        {canEdit ? (
                                            <input
                                                type="text"
                                                value={kycFields.cin}
                                                onChange={(e) => handleFieldChange('cin', e.target.value)}
                                                style={{
                                                    width: "100%",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                    padding: "8px",
                                                    fontSize: "14px"
                                                }}
                                                placeholder="Enter CIN number"
                                            />
                                        ) : (
                                            <span>{kycFields.cin || 'N/A'}</span>
                                        )}
                                    </td>
                                </tr> */}




                                {/* <tr>
                                    <td style={{
                                        padding: "10px",
                                        border: "1px solid #ddd",
                                        fontWeight: "bold"
                                    }}>
                                        CIN ID
                                    </td>
                                    <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                        {canEdit ? (
                                            <UploadImage name='cinImage' formik={formik} label='Upload CIN Document' />
                                        ) : (
                                            kycFields.cinImageUrl ? (
                                                <a
                                                    href={kycFields.cinImageUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <img
                                                        src={kycFields.cinImageUrl}
                                                        alt="CIN Document"
                                                        style={{
                                                            maxWidth: '100px',
                                                            maxHeight: '100px',
                                                            objectFit: 'contain'
                                                        }}
                                                    />
                                                </a>
                                            ) : 'N/A'
                                        )}
                                    </td>
                                </tr> */}


                                <tr>
                                    <td style={{
                                        width: "30%",
                                        padding: "10px",
                                        border: "1px solid #ddd",
                                        fontWeight: "bold"
                                    }}>
                                        Aadhar
                                    </td>
                                    <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                        {canEdit ? (
                                            <UploadImage name='aadharImage' formik={formik} />
                                        ) : (
                                            kycFields.aadharImageUrl ? (
                                                <a href={kycFields.aadharImageUrl} target="_blank" rel="noopener noreferrer">
                                                    {documentTypes.aadhar === 'pdf' ? (
                                                        <div style={{
                                                            width: '120px',
                                                            height: '120px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            background: '#f8f9fa',
                                                            border: '2px solid #dc3545',
                                                            borderRadius: '8px',
                                                            cursor: 'pointer'
                                                        }}>
                                                            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" fill="#dc3545" />
                                                                <polyline points="14,2 14,8 20,8" fill="#fff" />
                                                                <text x="12" y="16" textAnchor="middle" fill="#fff" fontSize="6" fontWeight="bold">PDF</text>
                                                            </svg>
                                                        </div>
                                                    ) : (
                                                        <img
                                                            src={kycFields.aadharImageUrl}
                                                            alt="Aadhar Document"
                                                            style={{
                                                                maxWidth: '120px',
                                                                maxHeight: '120px',
                                                                objectFit: 'contain',
                                                                cursor: 'pointer',
                                                                border: '1px solid #dee2e6',
                                                                borderRadius: '4px'
                                                            }}
                                                            onError={handleAadharImageError}
                                                        />
                                                    )}
                                                </a>
                                            ) : <span>N/A</span>
                                        )}
                                    </td>
                                </tr>


                                <tr>
                                    <td style={{
                                        padding: "10px",
                                        border: "1px solid #ddd",
                                        fontWeight: "bold"
                                    }}>
                                        GST Certificate
                                    </td>
                                    <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                        {canEdit ? (
                                            <UploadImage name='gstImage' formik={formik} />
                                        ) : (
                                            kycFields.gstImageUrl ? (
                                                <a href={kycFields.gstImageUrl} target="_blank" rel="noopener noreferrer">
                                                    {documentTypes.gst === 'pdf' ? (
                                                        <div style={{
                                                            width: '120px',
                                                            height: '120px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            background: '#f8f9fa',
                                                            // border: '2px solid #dc3545',
                                                            borderRadius: '8px',
                                                            cursor: 'pointer'
                                                        }}>
                                                            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" fill="#dc3545" />
                                                                <polyline points="14,2 14,8 20,8" fill="#fff" />
                                                                <text x="12" y="16" textAnchor="middle" fill="#fff" fontSize="6" fontWeight="bold">PDF</text>
                                                            </svg>
                                                        </div>
                                                    ) : (
                                                        <img
                                                            src={kycFields.gstImageUrl}
                                                            alt="GST Certificate"
                                                            style={{
                                                                maxWidth: '120px',
                                                                maxHeight: '120px',
                                                                objectFit: 'contain',
                                                                cursor: 'pointer',
                                                                border: '1px solid #dee2e6',
                                                                borderRadius: '4px'
                                                            }}
                                                            onError={handleGstImageError}
                                                        />
                                                    )}
                                                </a>
                                            ) : 'N/A'
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{
                                        padding: "10px",
                                        border: "1px solid #ddd",
                                        fontWeight: "bold"
                                    }}>
                                        PAN
                                    </td>
                                    <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                        {canEdit ? (
                                            <UploadImage name='panImage' formik={formik} />
                                        ) : (
                                            kycFields.panImageUrl ? (
                                                <a href={kycFields.panImageUrl} target="_blank" rel="noopener noreferrer">
                                                    {documentTypes.pan === 'pdf' ? (
                                                        <div style={{
                                                            width: '120px',
                                                            height: '120px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            background: '#f8f9fa',
                                                            // border: '2px solid #dc3545',
                                                            borderRadius: '8px',
                                                            cursor: 'pointer'
                                                        }}>
                                                            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" fill="#dc3545" />
                                                                <polyline points="14,2 14,8 20,8" fill="#fff" />
                                                                <text x="12" y="16" textAnchor="middle" fill="#fff" fontSize="6" fontWeight="bold">PDF</text>
                                                            </svg>
                                                        </div>
                                                    ) : (
                                                        <img
                                                            src={kycFields.panImageUrl}
                                                            alt="PAN Document"
                                                            style={{
                                                                maxWidth: '120px',
                                                                maxHeight: '120px',
                                                                objectFit: 'contain',
                                                                cursor: 'pointer',
                                                                border: '1px solid #dee2e6',
                                                                borderRadius: '4px'
                                                            }}
                                                            onError={handlePanImageError}
                                                        />
                                                    )}
                                                </a>
                                            ) : 'N/A'
                                        )}
                                    </td>
                                </tr>



                            </tbody>
                        </table>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={handleClose}
                        >
                            Close
                        </button>
                        {canEdit && (
                            <button
                                type="button"
                                className={`btn ${hasChanges ? 'btn-primary' : 'btn-secondary'}`}
                                onClick={handleSave}
                                disabled={!hasChanges || isLoading}
                                style={{
                                    marginLeft: "10px",
                                    opacity: hasChanges ? 1 : 0.6,
                                    cursor: hasChanges ? 'pointer' : 'not-allowed'
                                }}
                            >
                                {isLoading ? 'Saving...' : 'Save Changes'}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </Modal>
    );
};